
import React, { useState } from 'react';
import BlockButton from '../contacts/BlockButton';
import PriorityButton from '../contacts/PriorityButton';

import { ReactComponent as IconCall } from '../../assets/icons/call.svg';
import { ReactComponent as IconShare } from '../../assets/icons/share.svg';
import { ReactComponent as IconEdit } from '../../assets/icons/edit.svg';
import { ReactComponent as IconDetails } from '../../assets/icons/info.svg';
import { ReactComponent as IconDelete } from '../../assets/icons/trash.svg';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import {useNavigate} from "react-router-dom";
import {showError, ucwords} from "../../utils";
import {deleteContatti} from "../../api";
import useAlert from '../../hooks/useAlert';

export default function ContattoBtns({ itemGroup, setRawList, infoBtnTarget = 'show' }) {
    const navigate = useNavigate();
    const { id, numtel, cognome, nome, data_creazione, blocco, priorita, hanoteprerisposta} = itemGroup;
    const alert = useAlert();
    let cognomeLower = ucwords(cognome)
    let nomeLower = ucwords(nome)
    const prioritaOk = (priorita ? 'yes' : 'no') + (hanoteprerisposta ? '-with-note' : '');

    const [isLoadingDel, setIsLoadingDel] = useState(false);

    const handleDeleteContact = async () => {
        setIsLoadingDel(true);
        try{
            await deleteContatti([id]);
            window.history.back();
        }catch(err){
            showError([err.message]);
        }finally{
            setIsLoadingDel(false);
        }
    }

    return (
        <div className="vista-btns">
            <button><IconCall onClick={() => navigate('/call-actions', {state: { id, numero: numtel, chiamante_title: cognomeLower + " " + nomeLower }})} /></button>
            <button><IconShare onClick={async () => {
                try {
                    await navigator.share({
                        title: 'Condividi contatto',
                        text:  `Contatto: ${cognomeLower} ${nomeLower}\n
                                                        Telefono: ${numtel}`,
                    });
                    alert({message: 'Condivisione avvenuta con successo'});
                } catch (err) {
                    alert({message: 'Condivisione annullata o fallita:' + err, type: 'error'});
                }
            }} /></button>
            <BlockButton contactId={id} initial={blocco} setRawList={setRawList} />
            <PriorityButton contattoId={id} initial={prioritaOk} contatto_title={cognomeLower + " " + nomeLower} numero={numtel} />
            <button><IconEdit onClick={() => navigate('/contatto', { state: { id } })} /></button>
            {infoBtnTarget === 'show' ?
                <button><IconDetails onClick={() => navigate('/contatto-info', { state: { id } })} /></button> :
                <button>{isLoadingDel ? <IconLoading className="icon icon-loading"/>  : <IconDelete onClick={handleDeleteContact} />}</button>
            }
        </div>
    );
}
